export class COOKIES_CONFIG {

  static readonly LOGIN_USER = 'cookies:LOGIN_USER';
  static readonly LOGINED_LIST = 'cookies:LOGINED_LIST';
  static readonly DEVISE_UUID = 'cookies:DEVISE_UUID';
  static readonly API_TOKEN = 'cookies:API_TOKEN';
  static readonly API_URL = 'cookies:API_URL';
  static readonly CDC_CONTRACT = 'cookies:CDC_CONTRACT';
  static readonly SYSTEM_TYPE = 'cookies:SYSTEM_TYPE';
  static readonly COOKIES_VERSION_UP = 'cookies:COOKIES_VERSION_UP';
  static readonly SENSORS_OPTIONS = 'cookies:SENSORS_OPTIONS';

  // ダッシュボードデータ
  static readonly DASHBOARD_DATA = 'cookies:DASHBOARD_DATA';
  // ニコカレ
  static readonly NICOKARE_DATA = 'cookies:NICOKARE_DATA';
  // お知らせ
  static readonly NEWS_DATA = 'cookies:NEWS_DATA';
  // スタッフ一覧
  static readonly STAFFS_DATA = 'cookies:STAFFS_DATA';
  // 患者情報
  static readonly PATIENTS_DATA = 'cookies:PATIENTS_DATA';
  // 部屋情報
  static readonly ROOMS_DATA = 'cookies:ROOMS_DATA';
  static readonly ROOM_PATIENTS_DATA = 'cookies:ROOM_PATIENTS_DATA';
  // 契約情報
  static readonly CONTRACTS_DATA = 'cookies:CONTRACTS_DATA';
  // 契約情報詳細
  static readonly CONTRACT_DATA = 'cookies:CONTRACT_DATA';
  // センサー情報
  static readonly SENSORS_DATA = 'cookies:SENSORS_DATA';
  // センサーのログ
  static readonly SENSORS_LOGS = 'cookies:SENSORS_LOGS';
  static readonly SLEEP_SENSOR_LOGS = 'cookies:SLEEP_SENSOR_LOGS';
  static readonly NURSE_CALL_LOGS = 'cookies:NURSE_CALL_LOGS';
  static readonly SENSORS_SYNC_LOGS = 'cookies:SENSORS_SYNC_LOGS';


  static readonly REMOVE_LOGOUT_DATAS = [
    COOKIES_CONFIG.DASHBOARD_DATA,
    COOKIES_CONFIG.NICOKARE_DATA,
    COOKIES_CONFIG.STAFFS_DATA,
    COOKIES_CONFIG.PATIENTS_DATA,
    COOKIES_CONFIG.ROOMS_DATA,
    COOKIES_CONFIG.CONTRACTS_DATA,
    COOKIES_CONFIG.CONTRACT_DATA,
    COOKIES_CONFIG.SENSORS_DATA,
    COOKIES_CONFIG.SENSORS_LOGS,
    COOKIES_CONFIG.SLEEP_SENSOR_LOGS,
    COOKIES_CONFIG.NURSE_CALL_LOGS,
    COOKIES_CONFIG.SENSORS_SYNC_LOGS,
  ]

}



// WEBPACK FOOTER //
// ./src/configs/cookies.config.ts